import React, { ReactElement } from "react";
import classNames from "classnames";
import { useTicketState } from "../../../contexts/ticket-state";
import FilterPanel from "../../filters/FilterPanel";
import { SelectInstanceHandler } from "../../select/Select";
import Styles from "./ColumnPicker.module.scss";

export interface TicketStatesPickerProps<TIsMulti = false> {
    isMulti?: TIsMulti;
    className?: string;
    value?: (TIsMulti extends true ? string[] : string) | undefined;
    onSelected: (
        sourceId: (TIsMulti extends true ? string[] : string),
        text?: (TIsMulti extends true ? string[] : string)
    ) => void;
}

const ColumnPicker = React.forwardRef(<TIsMulti extends boolean = false>({
    isMulti, onSelected, className, value,
}: TicketStatesPickerProps<TIsMulti>, ref: React.ForwardedRef<HTMLElement>): ReactElement => {
    const ticketState = useTicketState();
    type ValueType = TIsMulti extends true ? Set<string> : string
    type SelectedType = TIsMulti extends true ? string[] : string

    const categories = ticketState.dashboardView?.getData().map((column, index) => ({
        value: column.ticketState.id,
        text: column.ticketState.name,
        label: (
            <div>
                {column.ticketState.name}
                <span className="ticket-count">
                    {column.groups.sum(group => group.length)}
                </span>
            </div>
        ),
    })) ?? [];
    return (
        <FilterPanel
            isMulti={isMulti}
            ref={ref}
            searchMinimum={5}
            categories={categories}
            itemClassName={classNames("column", Styles.column)}
            selectedCategories={(Array.isArray(value) ? new Set(value) : value) as unknown as ValueType}
            className={classNames("dont-hover", Styles.panel, className)}
            onSelected={selected => {
                onSelected((selected instanceof Set ? [...selected] : selected) as SelectedType);
            }}
        />
    );
});

ColumnPicker.defaultProps = {
    isMulti: false,
    className: undefined,
    value: undefined,
};

export default ColumnPicker as <
    TMulti extends boolean = false,
> (
    props: TicketStatesPickerProps<TMulti> & { ref?: React.ForwardedRef<SelectInstanceHandler> }
) => ReturnType<typeof ColumnPicker>;
